import { MoreHorizontal } from "lucide-react";
import { Checkbox } from "../ui/checkbox";
import { Button } from "../ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown-menu";
import { Input } from "../ui/input";
import { useState } from "react";
import { AvatarCustom } from "../ui/avatar";

interface DropdownCheckboxProps {
    options: {
        label: string;
        value: string;
        url?: string;
    }[];
    selected: string[];
    setSelected: (value: string[]) => void;
    selectAll?: boolean;
    search?: boolean;
    trigger?: React.ReactNode;
}

const DropdownCheckbox = ({ options, selected, setSelected, selectAll = false, search = false, trigger }: DropdownCheckboxProps) => {

    const [searchValue, setSearchValue] = useState('');

    const handleSelect = (value: string) => {
        const checked = !selected.includes(value);
        if (checked) {
            const newSelected = [...selected, value];
            setSelected(newSelected);
        } else {
            const newSelected = selected.filter(item => item !== value);
            setSelected(newSelected);
        }
    }

    const filteredOptions = options.filter(option => option.label.toLowerCase().includes(searchValue.toLowerCase()));

    const handleSelectAll = () => {
        if (options.length !== selected.length) {
            setSelected(options.map(option => option.value));
        } else {
            setSelected([]);
        }
    }
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                {trigger ? trigger : (
                    <Button>
                        <MoreHorizontal />
                    </Button>
                )}
            </DropdownMenuTrigger>
            <DropdownMenuContent className="max-h-[300px] overflow-y-auto bg-white">
                {search && (
                    <Input type="text" placeholder="Search" value={searchValue} onChange={(e) => setSearchValue(e.target.value)} />
                )}
                {selectAll && (
                    <DropdownMenuItem key="select-all" className="hover:bg-gray-100" onClick={() => handleSelectAll()}>
                        <Checkbox checked={selected.length === options.length} onCheckedChange={() => handleSelectAll()} />
                        Select All
                    </DropdownMenuItem>
                )}
                {filteredOptions.map((option) => (
                    <DropdownMenuItem key={option.value} className="hover:bg-gray-100" onClick={() => handleSelect(option.value)}>
                        <Checkbox checked={selected.includes(option.value)} onCheckedChange={() => handleSelect(option.value)} />
                        {option.url && (
                            <AvatarCustom src={option.url} alt={option.label} width={50} height={50} />
                        )}
                        {option.label}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    )
}

export default DropdownCheckbox;